import { IThemeColor } from "../schemamanager/themeColors";
import { IDefaultStyles } from '../schemamanager/types';
import { IDataTableComponent } from "./datatable";

export const tablestyle = (comp: IDataTableComponent, themeColor: () => IThemeColor): IDefaultStyles => {
    const style: IDefaultStyles = {
        main: {
            classes: {
            }
        },
        styleHeader: {
            classes: {
            }
        },
        styleTableContent: {
            classes: {
                display: 'grid',
                margin: 'mt-3'
            }
        },
        styleCardContent: {
            classes: {
                display: 'grid',
                margin: 'mt-3',
                gap: 'gap-2',
            },
            style: {gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))'}
        },
        styleTable: {
            classes: {
                tableLayout: 'table-auto',
                width: 'w-full'
            }
        },
        styleTableHead: {
            classes: {
            }
        },
        styleTableHeadRow: {
            classes: {
            }
        },
        styleTableHeaderCell: {
            classes: {
                textAlign: 'text-left',
                padding: 'px-4 py-2'
            }
        },
        styleTableCell: {
            classes: {
                padding: 'px-4 py-2'
            }
        },
        styleTableBody: {
            classes: {
            }
        },
        styleTableRow: {
            classes: {
                focus: {
                    outline: 'focus:outline-none',
                    backgroundColor: themeColor().focusBgColor
                },
                hover: {
                    backgroundColor: themeColor().hoverBgColorLighter
                }
            }
        },
        styleTableRowEven: {
            classes: {
            }
        },
        styleTableRowOdd: {
            classes: {
            }
        },
        styleCard: {
            classes: {
                display: 'flex',
                justifyContent: 'justify-between',
                alignItems: 'items-center',
                margin: 'my-2',
                padding: 'p-4',
                borderRadius: 'rounded',
                overflow: 'overflow-hidden',
                boxShadow: 'shadow-lg'
            }
        },
        styleCardEven: {
            classes: {
            }
        },
        styleCardOdd: {
            classes: {
            }
        },
    }
    const options = comp.options || {}

    if (options.tableBordered) {
        style.styleTableCell.classes!.borderWidth = 'border'
    } else {
        style.styleTableHeadRow.classes!.borderWidth = 'border-b'
        style.styleTableRow.classes!.borderWidth = 'border-b'
    }

    style.styleTableRowOdd.classes!.backgroundColor = themeColor().bgColorLight

    style.styleCardOdd.classes!.backgroundColor = themeColor().bgColorLight


    return style

}
